import { jsx as _jsx } from "react/jsx-runtime";
import { getModalidadesAtendimentos } from './modalidades_atendimentos.service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function ModalidadesAtendimentosListar() {
    return (_jsx(GridBase, { pagina: PAGINAS.MODALIDADES_ATENDIMENTOS, paginaPermissao: FUNCIONALIDADES.MODALIDADES_ATENDIMENTOS, rota: ROUTES.MODALIDADES_ATENDIMENTOS, fetchData: function (str, _filter, pag) { return getModalidadesAtendimentos(str, pag); }, columns: COLUNAS }));
}
export default ModalidadesAtendimentosListar;
